// extracted by mini-css-extract-plugin
export var clickableSpan = "MenuItem-module--clickableSpan--833dd";
export var current = "MenuItem-module--current--f95fa";
export var funBadge = "MenuItem-module--funBadge--7a566";
export var headline = "MenuItem-module--headline--55891";
export var inHeaderItem = "MenuItem-module--inHeaderItem--d469c";
export var newBadge = "MenuItem-module--newBadge--bfe46";
export var root = "MenuItem-module--root--ec447";
export var withBadge = "MenuItem-module--withBadge--281f3";